import React from 'react';
import ReactECharts from 'echarts-for-react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';

const PieChart = ({ data }) => {
  // Example data

  const options = {
    // title: {
    //   text: 'Bug Risk Share',
    //   left: 'center'
    // },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {d}%' // 'b' now refers to the 'label' property
    },
    // legend: {
    //   orient: 'vertical',
    //   left: 'left'
    // },
    series: [
      {
        name: 'Groups',
        type: 'pie',
        radius: '50%',
        data: data.map(item => ({
          value: item.value,
          name: startCase(
            item.label === 'priority' ? item.label.replace('priority', 'severity') : item.label.replaceAll('_', ' ')
          ) // Use 'label' property for the name in the chart
        })),
        label: {
          formatter: '{b}: {d}%' // 'b' now refers to the 'label' property
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1
          }
        }
      }
    ]
  };

  return <ReactECharts option={options} style={{ height: '400px', width: '100%' }} />;
};

export default PieChart;
PieChart.propTypes = {
  data: PropTypes.array
};
